import ApiService from '@/services/api.service.js';
import store from '@/store/index.js';

export default function usePricePeriodRepository() {
  const appsettings = store.state.appSettings;
  const isNotEmpty = (value) => value !== undefined && value !== null && value !== '';

  const load = (loadOptions) => {
    let params = '?';

    [
      'filter',
      'group',
      'groupSummary',
      'parentIds',
      'requireGroupCount',
      'requireTotalCount',
      'searchExpr',
      'searchOperation',
      'searchValue',
      'select',
      'sort',
      'skip',
      'take',
      'totalSummary',
      'userData',
    ].forEach((i) => {
      if (i in loadOptions && isNotEmpty(loadOptions[i])) {
        params += `${i}=${JSON.stringify(loadOptions[i])}&`;
      }
    });
    params = params.slice(0, -1);

    return ApiService
      .get(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/overview${params}`);
  };

  const update = (key, values) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${key}`, { values: JSON.stringify(values) });

  const insert = (values) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods`, { values: JSON.stringify(values) });

  const remove = (key) => ApiService
    .delete(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${key}`);

  const toggleActivateState = (key, value) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${key}/active/${value}`);

  const copy = (id, payload) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${id}/copy`, payload);

  const markup = (id, payload) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${id}/calculatemarkup`, payload);

  const priceindex = (id, payload) => ApiService
    .put(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${id}/applypriceindex`, payload);

  const importPriceList = (id, formData) => ApiService
    .post(`${appsettings.ADMINISTRATION_API}/api/v1/prices/pricingperiods/${id}/productprices/import`, formData);

  return {
    load,
    update,
    insert,
    remove,
    toggleActivateState,
    copy,
    markup,
    priceindex,
    importPriceList,
  };
}
